import * as Sentry from '@sentry/gatsby';

Sentry.init({
  dsn: 'https://991c1b13c2b64ea8975c73f425da9e92@o397725.ingest.us.sentry.io/6292695',
  sendDefaultPii: true,
  release: process.env.GATSBY_COMMIT_REF || new Date().toISOString(),
  integrations: [],
});
